import { Link } from "react-router-dom";
import Graphs from "./Graphs/Graphs";
import "./style.css";
import React, { useContext, useEffect } from "react";
import { studentDataContext } from "../../../contextAdmin/Admin/StudentData";

// Creator : Team e -
function RowExtension({ userDetails, setLastWPM }) {
  const { setstudentData, studentData } = useContext(studentDataContext)
  useEffect(() => { setstudentData(prev => userDetails) }, [])
  return (
    <div className="rowGrap">
      <Graphs userDetails={userDetails} setLastWPM={setLastWPM} />
      <Link state={userDetails} className="linkToStudentDetails" to="/StudentDetails">
        <img
          className="detailed"
          src={require("./detailed.png")}
          alt="detailed"
        />
      </Link>
    </div>
  );
}

export default RowExtension;
